import apiFetch from '../apiFetch'

export default function (token, documentId, organizedUnitId, fleetChargeId = null) {
  return apiFetch({ endPoint: `document/${documentId}/info?organizedUnitId=${organizedUnitId}&fleetChargeId=${fleetChargeId}`, method: 'GET', body: null, token: token })
}
